import React, { ReactNode, useContext } from 'react'
import clsx from 'clsx'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {
  CssBaseline,
  Box,
  Typography,
  Container,
  Grid,
  Link as LinkCopy,
  Button
} from '@material-ui/core'
import { Link } from 'react-router-dom'
import MainBar from '../components/layout/MainBar'
import Menu from '../components/layout/Menu'
import { LayoutContext } from '../context/LayoutContext'
import { drawerWidth } from '../types/Layout'
import Info from './Info'

function Copyright () {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <LinkCopy color="inherit" href="/">
        Portal Analytics
      </LinkCopy>{' '}
    </Typography>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    // paddingLeft: theme.spacing(10),

    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  menuOpen: {
    paddingLeft: drawerWidth
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    overflow: 'auto'
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),

    '&:nth-child(2)': {
      paddingLeft: theme.spacing(10)
    }
  },
  primary: {
    color: theme.palette.primary.light,
    textDecoration: 'none'
  },
  secondary: {
    color: theme.palette.secondary.light,
    textDecoration: 'none'
  }
}))

const ColorButtonActive = withStyles(() => ({
  root: {
    color: '#FFF',
    backgroundColor: '#043c61',
    borderColor: 'transparent',

    '&:hover': {
      backgroundColor: '#0a5180'
    }
  }
}))(Button)

const ColorButton = withStyles(() => ({
  root: {
    color: '#3f7cc2',
    borderColor: '#85c8e7',

    '&:hover': {
      backgroundColor: '#043c61',
      color: '#FFF',
      borderColor: 'transparent'
    }
  }
}))(Button)

type Props = {
  children: ReactNode;
}

export default function DailyMonitoringResumeTemplate ({
  children
}: Props): JSX.Element {
  const classes = useStyles()
  const { layout } = useContext(LayoutContext)
  const getActualUrl = window.location.pathname

  const path = {
    principal: '/monitoramento-diario/detalhe-principal',
    cancelados: '/monitoramento-diario/detalhe-cancelados',
    resumo: '/monitoramento-diario/detalhe-resumo',
    shoppingCart: '/monitoramento-diario/cesta-simultanea'
  }

  return (
    <div className={clsx(classes.root, layout.isMenuOpen && classes.menuOpen)}>
      <CssBaseline />
      <Menu />
      <MainBar />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="xl" className={classes.container}>
          <Info />
          <Grid
            item
            container
            spacing={1}
            justifyContent="space-between"
            className={classes.container}>
            <Grid item xs={12}>
              <Typography className={classes.root}>
                <Link to={path.principal} className={classes.secondary}>
                  {getActualUrl === path.principal
                    ? (
                    <ColorButtonActive variant="outlined" size="small">
                      Principal
                    </ColorButtonActive>
                      )
                    : (
                    <ColorButton variant="outlined" size="small">
                      Principal
                    </ColorButton>
                      )}
                </Link>
                <Link to={path.cancelados} className={classes.primary}>
                  {getActualUrl === path.cancelados
                    ? (
                    <ColorButtonActive variant="outlined" size="small">
                      Cancelados
                    </ColorButtonActive>
                      )
                    : (
                    <ColorButton variant="outlined" size="small">
                      Cancelados
                    </ColorButton>
                      )}
                </Link>
                <Link to={path.resumo} className={classes.primary}>
                  {getActualUrl === path.resumo
                    ? (
                    <ColorButtonActive variant="outlined" size="small">
                      Resumo
                    </ColorButtonActive>
                      )
                    : (
                    <ColorButton variant="outlined" size="small">
                      Resumo
                    </ColorButton>
                      )}
                </Link>
                <Link to={path.shoppingCart} className={classes.primary}>
                  {getActualUrl === path.shoppingCart
                    ? (
                    <ColorButtonActive variant="outlined" size="small">
                      CESTA SIMULTÂNEA
                    </ColorButtonActive>
                      )
                    : (
                    <ColorButton variant="outlined" size="small">
                      CESTA SIMULTÂNEA
                    </ColorButton>
                      )}
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Grid>{children}</Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  )
}
